import api from '@/api/tecnologico.api'

let servicio = {}

servicio.sistemasCon = () => {
    return api.get('/sistemas/sistemascon')
}

servicio.guardar = (data) => {
    return api.post('/sistemas/guardarsistema', data)
}

servicio.cambiarEstatus = (data) => {
    return api.post('/sistemas/cambiarestatussistema', data)
}

export default servicio
